// extracted by mini-css-extract-plugin
export default {"true":"styles_true__1Vkyo","false":"styles_false__d9Hxp"};